import AddToBasketRequestModelBase from '../_generated/modelBases/add-to-basket-request-model-base';

export default class AddToBasketRequestModel extends AddToBasketRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
